import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import LoadingPage from './auth/LoadingPage';

function Logout() {
  const navigate = useNavigate();
  const { currentUser, loading, logout } = useAuth();

  useEffect(() => {
    const performLogout = async () => {
      if (!loading && !currentUser) {
        // Already logged out, redirect to login
        navigate('/login', { replace: true });
        return;
      }

      if (!loading && currentUser) {
        // Perform logout
        try {
          await logout();
        } catch (error) {
          console.error('Logout error:', error);
          navigate('/login', { replace: true });
        }
      }
    };

    performLogout();
  }, [currentUser, loading, logout, navigate]);

  return <LoadingPage />;
}

export default Logout;
